/* Calypso redesign — product card hardware (metal) swatches.
   Delegated so it also covers cards added later (load-more / infinite scroll).
   Clicking a swatch sets that variant as the card's add-to-bag target and
   updates the displayed price. */
(function () {
  if (window.__calypsoCardInit) return;
  window.__calypsoCardInit = true;

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.cf-sw');
    if (!sw) return;
    var card = sw.closest('.cf-card');
    if (!card) return;
    e.preventDefault();

    var id = sw.getAttribute('data-variant');
    // sync both swatch groups (desktop panel + mobile) by variant id
    card.querySelectorAll('.cf-sw').forEach(function (s) {
      var on = id && s.getAttribute('data-variant') === id;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (id) {
      card.querySelectorAll('input[name="id"]').forEach(function (input) { input.value = id; });
    }
    var price = sw.getAttribute('data-price');
    if (price) {
      card.querySelectorAll('[data-cf-price], [data-cf-addprice]').forEach(function (el) { el.textContent = price; });
    }
  });
})();
